import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {UiConfig} from "../models/be.model";
import {BaseOutput} from "../models/fink.model";

/**
 * ui-config rows, served by uiconfig-service and reached through backoffice-be (remote-api-generator-plugin):
 * /backoffice/v1/uiConfig. Every response is the fink envelope, the row travels in `data`.
 */
@Injectable({ providedIn: 'root' })
export class PageConfigService {
    private http = inject(HttpClient);

    /** Backend resolves to the single most-specific row across tenant/role/user. */
    loadPageConfig(code: string): Observable<UiConfig> {
        return this.http.get<BaseOutput<UiConfig>>(`/backoffice/v1/uiConfig/code/${code}`)
            .pipe(map(res => res.data as UiConfig));
    }

    /**
     * Always saves a USER-scoped override (the service derives tenant/user from the caller) - GLOBAL/TENANT/ROLE rows
     * are admin/DB-only. An existing row is changed with a PATCH of the config only: code and scope never change.
     */
    saveUserConfig(code: string, config: any, aid?: string | null): Observable<UiConfig> {
        const request = aid
            ? this.http.patch<BaseOutput<UiConfig>>(`/backoffice/v1/uiConfig/${aid}/`, { data: { config } })
            : this.http.post<BaseOutput<UiConfig>>('/backoffice/v1/uiConfig', { data: { code, config } });
        return request.pipe(map(res => res.data as UiConfig));
    }

    /** Deletes a USER-scoped override, reverting the page to its ROLE/TENANT/GLOBAL fallback. */
    deleteUserConfig(aid: string): Observable<void> {
        return this.http.delete<BaseOutput<UiConfig>>(`/backoffice/v1/uiConfig/${aid}/`).pipe(map(() => void 0));
    }
}
